import { useEffect } from "react";
import { useToasts } from "react-toast-notifications";

const REDIRECT_DELAY_MS = 4000;

/**
 * Shown when the bulk-order URL carries credentials the backend rejects.
 * Tells the customer, then sends them back to the lookup form.
 */
const InvalidDetails = () => {
  const { addToast } = useToasts();

  useEffect(() => {
    addToast("You have entered incorrect details! Please check.", {
      appearance: "error",
    });

    const timer = setTimeout(() => {
      window.location.href = "/";
    }, REDIRECT_DELAY_MS);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default InvalidDetails;
